export enum ProjectType {
  Pro = 'pro',
  Sandbox = 'sandbox',
  Team = 'team',
}
